import * as commonScripts from '../common'

const cmpContactStandard = {
    component: null,

    init: function (element) {
        const _ = this
        _.component = element
        commonScripts.util.animationTranslate(this)
        const useReCaptchaElements = document.querySelectorAll('input[name="useReCaptcha"]');
        const reCaptchaSiteKeyElements = document.querySelectorAll('input[name="reCaptchaSiteKey"]');
        const reCaptchaTokenElements = document.querySelectorAll('input[name="reCaptchaToken"]');

        useReCaptchaElements.forEach((useReCaptcha, idx) => {
            if (useReCaptcha.value == "1") {
            const reCaptchaSiteKey = reCaptchaSiteKeyElements[idx];
            const reCaptchaToken = reCaptchaTokenElements[idx];

            if (reCaptchaSiteKey && typeof window.grecaptcha !== "undefined") {
                window.grecaptcha.ready(function () {
                    window.grecaptcha.execute(
                        reCaptchaSiteKey.value,
                        { action: "contactStandard" } // To validate the action name in backend
                    ).then(function (token) {
                        if (reCaptchaToken) {
                            reCaptchaToken.value = token;
                        }
                    });
                });
            }
            }
        });
        if (element.closest('#leadgenformPopupModal-content')) {
            //console.log("its leadgenform")
            element.classList.remove('contact-us-form')
            element.classList.add('lead-gen-form')

            let allFormTxtBox = element.querySelectorAll('.Form__Element')
            if (allFormTxtBox != null) {
                if (element.closest('.vertical-align-layout')) {
                    for (let i = 0; i < allFormTxtBox.length; i++) {
                        const element = allFormTxtBox[i];
                        // Remove existing width classes
                        element.className = element.className.replace(/col-\w+-\d+/g, '').trim();
                        // Add the new width class
                        element.classList.add('col-12');
                    }
                }
                else {
                    for (let i = 0; i < allFormTxtBox.length; i++) {
                        allFormTxtBox[i].classList.remove('col-lg-4');
                        allFormTxtBox[i].classList.add('col-lg-6');
                    }
                }
            }
        }
    }
}

export default cmpContactStandard